<div>
    <div class="main-container">
        <div class="document-view-continer pdf-content-container">
            <pdf-viewer [uuid]="fileViewValue"></pdf-viewer>
        </div>
        <div *ngIf="hasConfigured" class="table-continer">
            <div>
                <module-container>
                    <div class="title-container">
                        <h2>Unmapped Line Items</h2>
                    </div>
                    <abcis-table [configuration]="unMappedLineItemsTableConfig"
                        (onSelectRow)="onSelectUnMappedLineItem($event)"
                        (onUnSelectRow)="onSelectUnMappedLineItem($event)"></abcis-table>
                </module-container>
            </div>
            <div class="p-grid">
                <module-container>
                    <div>
                        <h2>Master Product</h2>
                    </div>
                    <div class="master-product-search-main-container p-grid ui-fluid">
                        <div class="master-product-dump-container"></div>
                        <div class="master-product-map-button p-col-12 p-md-4">
                            <div class="ui-inputgroup">
                                <button [ngStyle]="{ 'color' : disableMapBtn ? 'black' : ''  }"
                                    [disabled]="disableMapBtn === true" pButton type="button" label="Map Master Product"
                                    (click)="mapMasterData()" mat-flat-button class="submit-button"
                                    color="accent"></button>
                            </div>
                        </div>
                    </div>

                    <app-master-product-table (onSelectRow)="onSelectMasterProduct($event)" (onUnSelectRow)="onSelectMasterProduct($event)">
                    </app-master-product-table>
                </module-container>
            </div>
            <div>
                <module-container>
                    <div>
                        <h2>Mapped Line Items</h2>
                    </div>
                    <div class="master-product-search-main-container p-grid ui-fluid">
                        <div class="master-product-dump-container"></div>
                        <div class="master-product-map-button p-col-12 p-md-4">
                            <div class="ui-inputgroup">
                                <button [ngStyle]="{ 'color' : disableUnMapBtn ? 'black' : ''  }"
                                    [disabled]="disableUnMapBtn === true" pButton type="button" label="Unmap Line Items"
                                    (click)="unMapMasterData()" mat-flat-button class="submit-button"
                                    color="accent"></button>
                            </div>
                        </div>
                    </div>
                    <abcis-table [configuration]="mappedLineItemsTableConfig"
                        (onSelectRow)="onSelectMappedLineItem($event)" (onUnSelectRow)="onSelectMappedLineItem($event)">
                    </abcis-table>
                </module-container>
            </div>
            <!-- Dialog for confirmation before mapping. -->
            <p-dialog header="Confirm Action" [(visible)]="showMapDialog">
                <div class="display-isloading" *ngIf="displayIsLoading">
                    <p-progressSpinner></p-progressSpinner>
                </div>
                <div class="confirmMap-container">
                    <span>Are you sure you want to map the selected rows?</span>
                    <button pButton type="button" icon="pi pi-times" class="ui-button-danger"
                        (click)="showMapDialog = false;" label="No"></button>
                    <button pButton type="button" icon="pi pi-check" class="ui-button-success"
                        (click)="confirmMapMasterData()" label="Yes"></button>
                </div>
            </p-dialog>

            <!-- Dialog for confirmation before un-mapping. -->
            <p-dialog header="Confirm Action" [(visible)]="showUnMapDialog">
                <div class="display-isloading" *ngIf="displayIsLoading">
                    <p-progressSpinner></p-progressSpinner>
                </div>
                <div class="confirmMap-container">
                    <span>Are you sure you want to unmap the selected rows?</span>
                    <button pButton type="button" icon="pi pi-times" class="ui-button-danger"
                        (click)="showUnMapDialog = false;" label="No"></button>
                    <button pButton type="button" icon="pi pi-check" class="ui-button-success"
                        (click)="confirmUnMapMasteData()" label="Yes"></button>
                </div>
            </p-dialog>
        </div>
    </div>
</div>